import OptionDetailComponent from "./OptionDetailComponent.vue";

new Vue({
    el: '#option-detail',
    components: {OptionDetailComponent}
});
